import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvironmentService } from '../services/environment.service';
import { DeeplinkParams } from './state/actions';

@Injectable({
  providedIn: 'root'
})
export class DeeplinkHandlersService {

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) { }

  /**
   * Process Provet Send Invoice deeplink
   * @param practiceId - The practice ID
   * @param params - The deeplink parameters
   */
  processProvetSendInvoice(practiceId: string, params: DeeplinkParams): Observable<any> {
    const url = this.environmentService.get('backendUrl') + '/deeplink-handler/provet-send-invoice?practiceId=' + practiceId;
    
    const payload = {
      practiceId,
      invoiceId: params.invoiceId,
      user: params.user,
      provet_env: params.provet_env,
      provet_id: params.provet_id,
      department_id: params.department_id,
      timestamp: params.timestamp,
      verification: params.verification
    };

    return this.http.post<any>(url, payload, { withCredentials: true }).pipe(
      map((response: any) => response)
    );
  }
}